import {
  IFetchPrivateStatsParams,
  useFetchPrivateStatsQuery,
} from '../actions/fetchPrivateStats';
import { REFETCH_STATS_INTERVAL } from '../const';

export interface IUsePrivateStatsProps extends IFetchPrivateStatsParams {
  skipFetching?: boolean;
}

/**
 * @deprecated This hook is deprecated; please use `useFetchPrivateStatsQuery` directly instead.
 */
export const usePrivateStats = ({
  skipFetching,
  ...params
}: IUsePrivateStatsProps) => {
  const state = useFetchPrivateStatsQuery(params, {
    refetchOnMountOrArgChange: REFETCH_STATS_INTERVAL,
    skip: skipFetching,
  });

  const { data, isLoading } = state;

  return { loading: isLoading, params, privateStats: data, state };
};
